import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from 'src/app/appServices/toaster.service';
import { TranslationService } from 'src/app/appServices/translation.service';
import { IBasicInfo } from 'src/app/appModels/IBasicInfo';
import { RestaurantInfoResolver } from 'src/app/appServices/restaurant-info/restaurant-info.resolver';
import { LogoutResolver } from 'src/app/appServices/logout/logout.resolver';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  private basicInfo!: IBasicInfo;

  constructor(
    public toastMessage: ToasterService,
    private _logoutResolver: LogoutResolver,
    private navCtrl: NavController,
    private _restaurantInfoResolver: RestaurantInfoResolver,
    private injector: Injector
  ) {
    this._restaurantInfoResolver.restaurantBasicInfo.subscribe((res:any) => {
      this.basicInfo = res;
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isLoginRequest = request.url.includes('authenticate');

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const translate = this.injector.get(TranslationService);
        let errorMessage = translate.translate('SOMETHING_WENT_WRONG');

        if (error?.error === 'Unauthorized' || error.status === 401) {
          errorMessage = translate.translate('INVALID_CREDENTIALS');
          // Do not force logout/navigation for invalid login attempts.
          // Let the login page handle and show a proper invalid-credentials message.
          if (!isLoginRequest) {
            localStorage.removeItem('token');
            this._logoutResolver.logout();
            console.log('Logout Location: Server-error.interceptor | Line no 44');
            console.log(
              'Logout reason: error?.error === Unauthorized || error.status === 401'
            );
          }
          return throwError(() => new Error(errorMessage));
        }

        if (
          error?.status === 500 &&
          error.error.details &&
          error.error.details[0] === 'No Logged In User Found'
        ) {
          localStorage.removeItem('token');
          this._logoutResolver.logout();
          console.log('Logout Location: Server-error.interceptor | Line no 53');
          console.log(
            'Logout reason: error?.status === 500 && error.error.details && error.error.details[0] === No Logged In User Found'
          );

          errorMessage = error.error.details[0];
          this.toastMessage.errorToastWithClose(
            translate.translate('SESSION_TIMEOUT_PLEASE_LOGIN_AGAIN')
          );
          return throwError(() => new Error(errorMessage));
        }

        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
